import { PORTFOLIO } from '../data';
import './Education.css';

const UNC_LOGO = `${process.env.PUBLIC_URL}/unc-logo.svg`;

function Education() {
  const { education } = PORTFOLIO;

  return (
    <section id="education" className="section">
      <div className="section__head" data-reveal>
        <h2 className="section__title">Education</h2>
      </div>

      <div className="edu__school" data-reveal>
        <img
          src={UNC_LOGO}
          alt=""
          className="edu__logo"
          width="56"
          height="44"
          loading="lazy"
        />
        <div>
          <h3 className="edu__name">{education.school}</h3>
          <p className="edu__degree">{education.degree}</p>
        </div>
      </div>

      <div className="edu__grid">
        <div data-reveal>
          <p className="label">Relevant Coursework</p>
          <ol className="edu__courses">
            {education.coursework.map((course, i) => (
              <li className="edu__course" key={course}>
                <span className="edu__course-num" aria-hidden="true">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="edu__course-name">{course}</span>
              </li>
            ))}
          </ol>
        </div>

        <aside data-reveal style={{ '--d': '0.12s' }}>
          <p className="label">News I follow daily</p>
          <div className="edu__sources">
            {education.newsSources.map((source) => (
              <a
                key={source.name}
                href={source.url}
                target="_blank"
                rel="noopener noreferrer"
                className="edu__source"
              >
                <img
                  src={source.logo}
                  alt=""
                  className="edu__source-logo"
                  width="24"
                  height="24"
                  loading="lazy"
                />
                <span className="edu__source-name">{source.shortName}</span>
                <svg
                  className="edu__source-arrow"
                  viewBox="0 0 16 16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  aria-hidden="true"
                >
                  <path d="M3 8h10M9 4l4 4-4 4" />
                </svg>
              </a>
            ))}
          </div>
        </aside>
      </div>
    </section>
  );
}

export default Education;
